import React, { useMemo } from "react";
import Layout from "../components/layout";

export default function PhotographyPage() {
  const photos = useMemo(() => {
    // Auto-load everything inside `src/images/photography/`.
    // `require.context` is webpack-specific; in Jest/Node it won't exist.
    let req;
    try {
      req = require.context(
        "../images/photography",
        true,
        /\.(png|jpe?g|webp)$/i
      );
    } catch (e) {
      return [];
    }
    const keys = req.keys().slice();

    // Always render images from `/first 3/` at the top, then randomize the rest.
    const pinnedPrefix = "./first 3/";
    const pinned = keys.filter((k) => k.startsWith(pinnedPrefix)).sort();
    const rest = keys.filter((k) => !k.startsWith(pinnedPrefix));

    // Shuffle once per mount for a "random order" gallery.
    for (let i = rest.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [rest[i], rest[j]] = [rest[j], rest[i]];
    }

    return [...pinned, ...rest].map((key) => {
      const filepath = key.replace("./", "");
      const basename = filepath.split("/").pop() || filepath;
      const src = req(key);
      const url = src?.default ?? src;
      const alt = basename
        .replace(/\.[^.]+$/, "")
        .replace(/[-_]+/g, " ")
        .trim();
      return { url, alt, filename: filepath };
    });
  }, []);

  return (
    <Layout>
      <div className="container py-5 photography-page">
        <h1 className="mb-3">Photography</h1>
        <p className="text-muted mb-4">
          Product and lifestyle photography that supports your brand story.
        </p>

        <div className="photography-grid">
          {photos.map((photo) => (
            <div className="photography-grid__item" key={photo.filename}>
              <img
                className="photography-grid__img"
                src={photo.url}
                alt={photo.alt}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

